import RowWeb from "./web";
import { RowBlockProps } from "./types";

export function RowWebEditor(props: RowBlockProps) {
  return <RowWeb {...props} />;
}
